import { motion } from "framer-motion";
import { ArrowUpRight, Facebook } from "lucide-react";

const links = [
  { href: "#manifeste", label: "Manifeste", testid: "cpmc-nav-link-manifesto" },
  { href: "#programme", label: "Programme", testid: "cpmc-nav-link-curriculum" },
  { href: "#flyer", label: "Flyer promo", testid: "cpmc-nav-link-flyer" },
];

export default function Nav() {
  return (
    <motion.header
      data-testid="cpmc-header-navigation"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-ink/10 bg-cream/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
        <a href="#hero" className="flex items-center gap-3" data-testid="cpmc-nav-logo">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ink font-display text-sm font-bold text-cream">
            C
          </span>
          <span className="font-display text-base font-bold tracking-tight">
            CPMC <span className="text-teal">·</span> Québec
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="group relative font-mono text-xs uppercase tracking-[0.2em] text-ink/70 transition-colors hover:text-ink"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-teal transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://www.facebook.com/patdeegan.pda/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Page Facebook Pat Deegan"
            data-testid="cpmc-nav-link-facebook"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-ink/15 text-ink/70 transition-colors duration-300 hover:border-teal hover:text-teal-dark"
          >
            <Facebook className="h-4 w-4" />
          </a>
          <span
            data-testid="cpmc-nav-badge-quebec"
            className="hidden rounded-full border border-teal/40 bg-teal/10 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-teal-dark sm:inline-block"
          >
            Nouveau · Français
          </span>
          <a
            href="#inscription"
            data-testid="cpmc-nav-btn-register"
            className="group flex items-center gap-1.5 rounded-full bg-ink px-4 py-2 text-sm font-semibold text-cream transition-transform duration-300 hover:scale-105"
          >
            S'inscrire
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
    </motion.header>
  );
}
